<template>
	<v-badge left color="red" v-model="shouldShow">
		<span slot="badge">{{itemCount}}</span>
	</v-badge>
</template>

<script>
	import { mapGetters } from "vuex";

	export default {
		name: "message-badge",

		computed: {
			...mapGetters({
				GET_VALUE: "getValue"
			}),

			itemCount () {
				return this.getObjectValue("list.length", this);
			},

			shouldShow () {
				return this.itemCount > 0;
			},

			list () {
				if (this.name !== null) {
					let value = this.GET_VALUE(this.name, this.isState);

					if(typeof value === 'function') {
						return value(...this.params);
					}

					return value;
				}

				return this.items;
			}
		},

		props: {
			items: {
				default () {
					return [];
				}
			},

			name: {
				default: null,
				type:    String
			},

			isState: {
				default: false,
				type:    Boolean
			},

			params: {
				default() {
					return [];
				},
				type: Array
			},
		}
	};
</script>
